var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_95_3378)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_95_3378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 34.9999C27.1649 34.9999 34.9999 27.1649 34.9999 17.5C34.9999 7.835 27.1649 0 17.5 0C7.835 0 0 7.835 0 17.5C0 27.1649 7.835 34.9999 17.5 34.9999Z",
    fill: "#4F6288"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9524 23.8779C16.7743 23.8779 16.5964 23.8083 16.4654 23.6707C16.2149 23.4077 16.2298 22.996 16.4987 22.7511C17.6165 21.7327 19.5636 21.1001 21.5801 21.1001C23.6886 21.1001 25.5832 21.7235 26.6482 22.7677C26.9077 23.0222 26.9071 23.4341 26.6469 23.6878C26.3867 23.9416 25.9654 23.941 25.7058 23.6866C24.8974 22.8939 23.3164 22.4015 21.5801 22.4015C19.8868 22.4015 18.2873 22.9003 17.4059 23.7033C17.2776 23.8201 17.1148 23.8779 16.9524 23.8779Z",
    fill: "#322E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7779 14.4444C14.0052 14.4444 15.0001 13.4495 15.0001 12.2222C15.0001 10.9949 14.0052 10 12.7779 10C11.5506 10 10.5557 10.9949 10.5557 12.2222C10.5557 13.4495 11.5506 14.4444 12.7779 14.4444Z",
    fill: "#322E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0223 14.4444C27.2496 14.4444 28.2445 13.4495 28.2445 12.2222C28.2445 10.9949 27.2496 10 26.0223 10C24.795 10 23.8 10.9949 23.8 12.2222C23.8 13.4495 24.795 14.4444 26.0223 14.4444Z",
    fill: "#322E30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.25 32.4165C11.5851 32.4165 3.7501 24.5815 3.7501 14.9166C3.7501 9.75296 5.98695 5.11241 9.54401 1.90918C3.87855 4.80596 0 10.7 0 17.5C0 27.1649 7.83496 34.9999 17.4999 34.9999C22.0013 34.9999 26.1051 33.2998 29.2059 30.5075C26.8189 31.7279 24.115 32.4165 21.25 32.4165Z",
    fill: "#3C4F73"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_95_3378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_95_3378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSad);
export default __webpack_public_path__ + "static/media/Sad.9dc8fe6b06c3b82744994437b166e490.svg";
export { ForwardRef as ReactComponent };